/**
 * Created by ravi.teja on 19-11-2021.
 */
(function (ws) {
    'use strict';
    ws.models.savedCartDeleteModalModel = Backbone.Model.extend({
        url: function () {
            return globals.path.api.westcon.removeCart;
        }
    });
})(westcon);

